const wizard = document.querySelector('[data-booking-wizard]');

if (wizard) {
  const bookingStep = wizard.querySelector('[data-booking-step="booking"]');
  const detailsStep = wizard.querySelector('[data-booking-step="details"]');
  const scheduler = wizard.querySelector('[data-booking-scheduler]');
  const bookingFrame = wizard.querySelector('[data-bookings-frame]');
  const openButton = wizard.querySelector('[data-booking-open]');
  const confirmButton = wizard.querySelector('[data-booking-confirm]');
  const formMount = wizard.querySelector('[data-apollo-mount]');
  const errorMessage = wizard.querySelector('[data-apollo-error]');
  const fallbackLink = wizard.querySelector('[data-bookings-fallback]');
  if (fallbackLink) fallbackLink.href = __BOOKINGS_URL__;
  const journeyKey = document.body.dataset.journey || 'general';
  const journeyValue = __JOURNEY_VALUES__[journeyKey] || __JOURNEY_VALUES__.general;
  let apolloInitialized = false;

  const emit = (eventName, parameters = {}) => {
    document.dispatchEvent(new CustomEvent('campaign:track', { detail: { eventName, parameters } }));
  };

  const showError = () => {
    errorMessage.hidden = false;
    errorMessage.querySelector('a').href = __BOOKINGS_URL__;
  };

  const observeApolloForm = () => {
    const attach = (form) => {
      if (form.dataset.jdmsTracked) return;
      form.dataset.jdmsTracked = 'true';
      form.addEventListener('focusin', () => emit('form_started', { form_id: 'apollo-form' }), { once: true });
      form.addEventListener('submit', () => emit('form_submit_attempted', { form_id: 'apollo-form' }));
    };
    formMount.querySelectorAll('form').forEach(attach);
    new MutationObserver(() => formMount.querySelectorAll('form').forEach(attach))
      .observe(formMount, { childList: true, subtree: true });
  };

  const initializeApollo = () => {
    if (apolloInitialized) return;
    apolloInitialized = true;

    const url = new URL(location.href);
    url.searchParams.set('journey', journeyValue);
    url.searchParams.set('campaign', document.body.dataset.campaign || '');
    url.searchParams.set('site', __SITE_ID__);
    history.replaceState(history.state, '', url);

    observeApolloForm();
    const script = document.createElement('script');
    script.src = `https://assets.apollo.io/js/apollo-inbound.js?nocache=${Math.random().toString(36).substring(7)}`;
    script.async = true;
    script.onerror = () => {
      console.error('[Apollo] Failed to load Form Builder script');
      showError();
    };
    script.onload = () => {
      try {
        const initialization = window.ApolloInbound.forms.init({ appId: __APOLLO_FORM_APP_ID__ });
        initialization?.catch?.((error) => {
          console.error('[Apollo] Error initializing Form Builder:', error);
          showError();
        });
      } catch (error) {
        console.error('[Apollo] Error initializing Form Builder:', error);
        showError();
      }
    };
    document.head.appendChild(script);
  };

  openButton.addEventListener('click', () => {
    if (!bookingFrame.src) bookingFrame.src = __BOOKINGS_URL__;
    scheduler.hidden = false;
    openButton.hidden = true;
    emit('booking_started', { booking_provider: 'microsoft_bookings' });
    bookingFrame.focus();
  });

  confirmButton.addEventListener('click', () => {
    bookingStep.hidden = true;
    detailsStep.hidden = false;
    wizard.dataset.currentStep = 'details';
    emit('booking_completed', {
      booking_provider: 'microsoft_bookings',
      confirmation_method: 'self_reported'
    });
    initializeApollo();
    detailsStep.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });
}
